import React, { Component, Fragment } from "react";
import "./sizing.css";
import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";
import { getOGPurities, getOGFlowByPurityId, getModelByParameters } from "../../constants/sizing-constant";
import { Link } from "react-router-dom";

export default class O2Sizing extends Component {

    state = {
        OGPurities: [],
        selectedO2Purity: "0",
        flowRate: [],
        selectedFlowRate: "0",
        suggestedModel: "",
        suggestedModelId:""
    };

    componentDidMount() {
        this.setState({ OGPurities: [...getOGPurities()] });
    };

    componentWillReceiveProps(Values) {
        this.setState({ products: Values.products });
    };

    handlO2PuritySelect = purity => {
        if (purity) {
            this.setState({ selectedO2Purity: purity.value });
            this.setState({ flowRate: [...getOGFlowByPurityId(purity.value)] });
        }
    };

    handleFlowRateSelect = flowRate => {
        this.setState({ selectedFlowRate: flowRate.value }, () => {
            this.findModel();
        });
    };


    findModel() {
        var result = getModelByParameters("4",this.state.selectedFlowRate)[0] ;
        this.setState({ suggestedModel: result.label });
        this.setState({ suggestedModelId: result.Id });
    }

    render() {
        return (
            <Fragment>
                <h6 className="text-title-desc">دمای طراحی در نظر گرفته شده در محاسبات برای اکسیژن ساز 30 درجه سانتی گراد می باشد</h6>
                <DropDownWhiteStyle
                    items={this.state.OGPurities}
                    placeholder="درصد خلوص"
                    onItemSelect={this.handlO2PuritySelect}
                    value={this.state.selectedO2Purity}
                />
                {this.state.selectedO2Purity !== "0" &&
                    < Fragment >
                        <DropDownWhiteStyle
                            items={this.state.flowRate}
                            placeholder="خروجی مورد نیاز"
                            onItemSelect={this.handleFlowRateSelect}
                            value={this.state.selectedFlowRate}
                        />
                    </Fragment>
                }
                {this.state.suggestedModel !== "" &&
                    <Fragment>
                        <h1 className="text-title-body">مدل پیشنهادی برای شما :</h1>
                        <div className="modelheadbox">
                            <h1 >{this.state.suggestedModel}</h1>
                            <hr className="divider" />
                        </div>
                        <h3 className="text-title-description">فشار هوای ورودی به اکسیژن ساز: بین ۴ تا ۸ Bar g</h3>
                        <h3 className="text-title-description">فشار اکسیژن تولیدی: بین ۴ تا ۶ Bar g</h3>
                        <div className="row hrow mt-4">
                            <Link className="btn btn-dark" to={`/partRequst/${this.state.suggestedModelId}`} >درخواست خرید این مدل</Link>
                        </div>
                    </Fragment>
                }
            </Fragment>
        );
    }
}
